import { SwitchUnstyled } from '@mui/base';
import { CircularProgress } from '@mui/material';
import classNames from 'classnames';
import { ChangeEvent, FC } from 'react';
import { LoadingAction } from 'src/store/models/Action';
import { useLoadingSelector } from 'src/utils/useLoadingSelector';

import classes from './Switch.module.scss';

export interface SwitchProps {
  checked?: boolean;
  className?: string;
  handleChange?: (e: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  disabled?: boolean;
  height?: number;
  width?: number;
  borderWidth?: number;
  loading?: LoadingAction;
  classes?: {
    root?: string;
    loading?: string;
  };
}

const Switch: FC<SwitchProps> = ({
  checked = false,
  className,
  handleChange,
  disabled = false,
  height = 16,
  width = 32,
  borderWidth = 1.5,
  loading,
  classes: switchClasses,
}) => {
  const thumbSize = height - borderWidth * 2;

  const loadingSwitch = useLoadingSelector(loading);

  return (
    <div className={classNames(classes.Root, switchClasses?.root)}>
      <SwitchUnstyled
        componentsProps={{
          root: {
            style: {
              width: `${width}px`,
              height: `${height}px`,
            },
            onClick: (e) => e.stopPropagation(),
          },
          thumb: {
            style: {
              width: `${thumbSize}px`,
              height: `${thumbSize}px`,
              borderWidth: `${borderWidth}px`,
              left: checked ? width - height : 0,
            },
          },
          track: {
            style: {
              width: `calc(100% - ${borderWidth * 2}px`,
              height: `calc(100% - ${borderWidth * 2}px`,
              borderWidth: `${borderWidth}px`,
            },
          },
        }}
        checked={checked}
        onChange={(e) => handleChange?.(e, e.target?.checked)}
        className={classNames(classes.Switch, className, {
          [classes.Checked]: checked,
          [classes.Disabled]: disabled || loadingSwitch,
        })}
        disabled={disabled || loadingSwitch}
      />
      {loadingSwitch && <CircularProgress color="primary" size={height} />}
    </div>
  );
};

export default Switch;
